/* Flexacare theme — global.js */
(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      mobileMenu.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
    });
    mobileMenu.querySelectorAll('[data-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        mobileMenu.removeAttribute('open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ---------- Cart drawer ---------- */
  function drawer() { return document.querySelector('[data-cart-drawer]'); }
  // Lets the Flexacare dispenser add-on re-render the drawer.
  window.fxRefreshCart = function (open) { return refreshCart(open); };

  function openCart() {
    var d = drawer();
    if (!d) return;
    d.hidden = false;
    // Commit the off-screen start position with a forced reflow, then transition in.
    // requestAnimationFrame is unreliable here: it does not fire in background tabs,
    // which would leave the drawer open but invisible.
    void d.offsetWidth;
    d.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var closeBtn = d.querySelector('[data-cart-close]');
    if (closeBtn && closeBtn.focus) closeBtn.focus();
  }

  function closeCart() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    document.body.style.overflow = '';
    window.setTimeout(function () { if (!d.classList.contains('is-open')) d.hidden = true; }, 280);
  }

  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  // Re-render the drawer from the server so money formatting stays correct.
  function refreshCart(thenOpen) {
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + '?sections=cart-drawer'
        : '/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var markup = data['cart-drawer'];
        if (!markup) return;
        var parsed = new DOMParser().parseFromString(markup, 'text/html');
        var fresh = parsed.querySelector('#shopify-section-cart-drawer') || parsed.body;
        var current = document.querySelector('#shopify-section-cart-drawer');
        if (current && fresh) {
          var wasOpen = document.querySelector('[data-cart-drawer]') &&
                        document.querySelector('[data-cart-drawer]').classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          bindDrawer();
          if (wasOpen) {
            var d = drawer();
            if (d) { d.hidden = false; d.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
          } else if (thenOpen) {
            openCart();
          }
        }
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCartCount(c.item_count); });
      })
      .catch(function () { window.location.href = '/cart'; });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () { return refreshCart(false); });
  }

  // Bind controls that live inside the drawer (re-run after every refresh).
  function bindDrawer() {
    var d = drawer();
    if (!d) return;

    d.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (btn.tagName === 'A' && btn.getAttribute('href')) return; // let links navigate
        e.preventDefault();
        closeCart();
      });
    });

    d.querySelectorAll('[data-qty][data-line]').forEach(function (wrap) {
      var input = wrap.querySelector('[data-line-qty]');
      var line = parseInt(wrap.dataset.line, 10);
      wrap.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = parseInt(input.value || '1', 10);
          v = btn.dataset.dir === 'up' ? v + 1 : v - 1;
          if (v < 0) v = 0;
          input.value = v;
          changeLine(line, v);
        });
      });
      input.addEventListener('change', function () {
        var v = parseInt(input.value || '0', 10);
        changeLine(line, isNaN(v) || v < 0 ? 0 : v);
      });
    });

    d.querySelectorAll('[data-line-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(parseInt(btn.dataset.lineRemove, 10), 0);
      });
    });

    var protect = d.querySelector('[data-protection-toggle]');
    if (protect) {
      protect.addEventListener('click', function () {
        var on = protect.classList.contains('is-on');
        var id = protect.dataset.variantId;
        protect.classList.toggle('is-on', !on);
        protect.setAttribute('aria-checked', String(!on));
        if (on) {
          // find the line holding the protection variant and drop it
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var idx = cart.items.findIndex(function (i) { return String(i.variant_id) === String(id); });
            if (idx > -1) changeLine(idx + 1, 0); else refreshCart(false);
          });
        } else {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
          }).then(function () { return refreshCart(false); });
        }
      });
    }
  }

  document.querySelectorAll('[data-cart-toggle]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (!drawer()) return; // no drawer: fall through to the /cart page
      e.preventDefault();
      if (mobileMenu) { mobileMenu.removeAttribute('open'); }
      openCart();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  bindDrawer();

  /* ---------- Quantity steppers outside the drawer ---------- */
  document.querySelectorAll('[data-qty]:not([data-line])').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    if (!input) return;
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(input.value || '1', 10);
        v = btn.dataset.dir === 'up' ? v + 1 : Math.max(1, v - 1);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- Product form: variants, subscription pricing, add to cart ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var plansEl = form.querySelector('[data-plans-json]');
    var plans = {};
    if (plansEl) { try { plans = JSON.parse(plansEl.textContent) || {}; } catch (e) { plans = {}; } }

    var idInput = form.querySelector('input[name="id"]');
    var planInput = form.querySelector('[data-selling-plan-input]');
    var refillBox = form.querySelector('[data-refill-toggle]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare-price]');
    var button = form.querySelector('[data-add-button]');
    var buttonText = button ? button.querySelector('span') : null;
    var money = form.dataset.moneyFormat || '${{amount}}';
    var packList = form.querySelector('[data-pack-list]');
    var noteSubOnly = !!(packList && packList.dataset.noteSubscriptionOnly === 'true');

    function fmt(cents) {
      var amount = (cents / 100).toFixed(2);
      return money
        .replace(/\{\{\s*amount\s*\}\}/, amount)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    }
    function subscribing() { return !!(refillBox && refillBox.checked); }

    // Price a variant, honouring the subscription plan when refills are ticked.
    function priceOf(variant) {
      var plan = variant ? plans[variant.id] : null;
      if (subscribing() && plan) {
        return {
          price: plan.price,
          // "Was" price for a subscription is the pack's list price, not the one-time price.
          compare: plan.compare_at_price || variant.compare_at_price || variant.price || null,
          planId: plan.id
        };
      }
      return {
        price: variant ? variant.price : 0,
        compare: variant ? variant.compare_at_price : null,
        planId: null
      };
    }
    function selected() {
      return Array.from(form.querySelectorAll('[data-option-index]')).map(function (fs) {
        var checked = fs.querySelector('input:checked');
        if (checked) return checked.value;
        var sel = fs.querySelector('select');
        return sel ? sel.value : null;
      });
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    // Re-price every pack card for the current colour and subscription choice.
    function refreshPacks() {
      var packField = form.querySelector('[data-option-index] [data-pack-card]');
      if (!packField) return;
      var fieldset = packField.closest('[data-option-index]');
      if (!fieldset) return;
      var packIndex = parseInt(fieldset.dataset.optionIndex, 10);
      var base = selected();

      form.querySelectorAll('[data-pack-card]').forEach(function (card) {
        var opts = base.slice();
        opts[packIndex] = card.dataset.packValue;
        var variant = findVariant(opts);
        var p = priceOf(variant);

        var priceSpan = card.querySelector('[data-pack-price]');
        var compareSpan = card.querySelector('[data-pack-compare]');
        var offSpan = card.querySelector('[data-pack-off]');
        var noteSpan = card.querySelector('[data-pack-note]');

        if (priceSpan) priceSpan.textContent = fmt(p.price);
        if (compareSpan) {
          if (p.compare && p.compare > p.price) {
            compareSpan.textContent = fmt(p.compare);
            compareSpan.hidden = false;
          } else {
            compareSpan.hidden = true;
          }
        }
        if (offSpan) {
          if (p.compare && p.compare > p.price) {
            offSpan.textContent = Math.round((p.compare - p.price) / p.compare * 100) + '% off';
            offSpan.hidden = false;
          } else {
            offSpan.hidden = true;
          }
        }
        if (noteSpan && noteSubOnly) noteSpan.hidden = !subscribing();
      });
    }

    function update() {
      var opts = selected();
      var match = findVariant(opts);
      if (!match) {
        if (button) { button.disabled = true; if (buttonText) buttonText.textContent = 'Unavailable'; }
        return;
      }
      var p = priceOf(match);
      idInput.value = match.id;
      if (planInput) {
        planInput.value = p.planId || '';
        planInput.disabled = !p.planId;
      }
      if (priceEl) priceEl.textContent = fmt(p.price);
      if (compareEl) {
        if (p.compare && p.compare > p.price) { compareEl.textContent = fmt(p.compare); compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      if (button) {
        button.disabled = !match.available;
        if (buttonText) buttonText.textContent = match.available ? (button.dataset.addText || 'Add to cart') : 'Sold out';
      }
      if (match.featured_media && match.featured_media.id) {
        var thumb = document.querySelector('[data-thumb][data-media-id="' + match.featured_media.id + '"]');
        if (thumb) thumb.click();
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
      refreshPacks();
    }

    form.querySelectorAll('[data-option-index] input, [data-option-index] select').forEach(function (el) {
      el.addEventListener('change', update);
    });
    if (refillBox) refillBox.addEventListener('change', update);
    update();

    form.addEventListener('submit', function (e) {
      if (!drawer()) return;
      e.preventDefault();
      if (button) { button.disabled = true; if (buttonText) buttonText.textContent = 'Adding\u2026'; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.body && res.body.description) || 'Could not add to cart');
          return refreshCart(true);
        })
        .catch(function (err) { window.alert(err.message || 'Sorry, that could not be added to your cart.'); })
        .finally(function () {
          if (button) { button.disabled = false; if (buttonText) buttonText.textContent = button.dataset.addText || 'Add to cart'; }
        });
    });
  });

  /* ---------- Product gallery thumbnails ---------- */
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('[data-main-image]');
      if (!main) return;
      var img = thumb.querySelector('img');
      main.src = thumb.dataset.src || img.src;
      main.srcset = '';
      main.alt = img.alt;
      document.querySelectorAll('[data-thumb]').forEach(function (t) { t.removeAttribute('aria-current'); });
      thumb.setAttribute('aria-current', 'true');
    });
  });

  /* ---------- Page transitions ---------- */
  // Fade the main content in on arrival, and out on the way to another page,
  // so moving between Home, Mouth Tape, FAQ and so on feels continuous.
  (function () {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;
    var main = document.querySelector('.main-content');
    if (!main) return;

    document.body.classList.add('page-ready');

    var bar = document.querySelector('[data-page-progress]');
    function runBarIn() {
      if (!bar) return;
      bar.style.transition = 'none';
      bar.style.width = '0%';
      bar.style.opacity = '1';
      void bar.offsetWidth;
      bar.style.transition = 'width .5s cubic-bezier(.16,1,.3,1), opacity .3s ease .45s';
      bar.style.width = '100%';
      bar.style.opacity = '0';
    }
    function runBarOut() {
      if (!bar) return;
      bar.style.transition = 'none';
      bar.style.width = '0%';
      bar.style.opacity = '1';
      void bar.offsetWidth;
      bar.style.transition = 'width .32s cubic-bezier(.4,0,.2,1)';
      bar.style.width = '72%';
    }
    runBarIn();

    function leavesSite(a) {
      try { return new URL(a.href, location.href).origin !== location.origin; }
      catch (e) { return true; }
    }

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download')) return;
      if (/^(mailto:|tel:|javascript:)/i.test(href)) return;
      if (a.hasAttribute('data-cart-toggle') || a.hasAttribute('data-spin-close')) return;
      if (leavesSite(a)) return;
      // same page, different hash only
      var dest = new URL(a.href, location.href);
      if (dest.pathname === location.pathname && dest.search === location.search) return;

      e.preventDefault();
      runBarOut();
      document.body.classList.add('page-leaving');
      window.setTimeout(function () { window.location.href = a.href; }, 260);
    });

    // Coming back via the browser's back button restores a cached page mid-fade
    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted) { document.body.classList.remove('page-leaving'); runBarIn(); }
    });
  })();

  /* ---------- Scroll reveal ---------- */
  (function () {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) return;
    var main = document.querySelector('.main-content');
    if (!main) return;

    function isRow(el) {
      var d = getComputedStyle(el).display;
      return d === 'grid' || d === 'flex';
    }

    // Two-column splits get a directional slide — the image comes in from its own
    // side and the copy from the other. Card grids just rise, which reads calmer.
    function sideOf(el, parent) {
      var pr = parent.getBoundingClientRect();
      var er = el.getBoundingClientRect();
      if (!pr.width || er.width > pr.width * 0.72) return null;
      var offset = ((er.left + er.width / 2) - (pr.left + pr.width / 2)) / pr.width;
      if (offset < -0.12) return 'reveal--left';
      if (offset > 0.12) return 'reveal--right';
      return null;
    }

    var targets = [];
    main.querySelectorAll('.container').forEach(function (container) {
      if (container.closest('[data-no-reveal]')) return;
      var kids = Array.prototype.slice.call(container.children);
      if (!kids.length) return;
      var containerIsPair = kids.length === 2 && isRow(container);

      kids.forEach(function (el) {
        var box = el.getBoundingClientRect();
        // Only break a block into its children when those children are real
        // content cards; short icon rows should animate as one piece.
        var splittable = isRow(el) && el.children.length >= 2 &&
                         el.children.length <= 24 && box.height >= 150;
        if (splittable) {
          var innerPair = el.children.length === 2;
          Array.prototype.forEach.call(el.children, function (kid) {
            targets.push([kid, innerPair ? sideOf(kid, el) : null]);
          });
        } else {
          targets.push([el, containerIsPair ? sideOf(el, container) : null]);
        }
      });
    });
    if (!targets.length) return;

    targets = targets.map(function (pair) {
      pair[0].classList.add('reveal');
      if (pair[1]) pair[0].classList.add(pair[1]);
      return pair[0];
    });

    function show(el, delay) {
      el.style.setProperty('--reveal-delay', (delay || 0) + 'ms');
      el.classList.add('is-revealed');
      window.setTimeout(function () { el.setAttribute('data-reveal-done', ''); }, 900 + (delay || 0));
    }

    // Whatever is already on screen animates in straight away, lightly staggered.
    var onLoadDelay = 0;
    var pending = [];
    targets.forEach(function (el) {
      var box = el.getBoundingClientRect();
      if (box.top < window.innerHeight * 0.9) {
        show(el, onLoadDelay);
        onLoadDelay += 70;
      } else {
        pending.push(el);
      }
    });

    var groupStart = 0;
    var groupCount = 0;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var now = Date.now();
        // Entries that arrive together get a stagger; a lone one does not wait.
        if (now - groupStart > 220) { groupStart = now; groupCount = 0; }
        show(entry.target, groupCount * 90);
        groupCount += 1;
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    pending.forEach(function (el) { io.observe(el); });

    // Safety net: never leave content invisible if something goes wrong — but only
    // for what the visitor can actually reach. Revealing every target on a timer
    // meant anything below a long section (the 450vh 3D showcase takes far more
    // than six seconds to scroll) was already revealed before it came into view,
    // so it never animated. Sweep what is at or above the fold and leave the rest
    // to the observer.
    var netTimer = window.setInterval(function () {
      var waiting = 0;
      targets.forEach(function (el) {
        if (el.classList.contains('is-revealed')) return;
        if (el.getBoundingClientRect().top < window.innerHeight) { show(el, 0); return; }
        waiting += 1;
      });
      if (!waiting) window.clearInterval(netTimer);
    }, 4000);
  })();

  /* ---------- Header tucks away, sticky shop bar takes its place ---------- */
  (function () {
    var header = document.querySelector('.site-header');
    var headerHolder = header ? (header.closest('.shopify-section') || header) : null;
    var bar = document.querySelector('[data-shop-bar]');
    if (!header && !bar) return;

    var SHOW_AFTER = 260;   // don't touch anything until we're clear of the hero
    var DEADZONE = 6;       // ignore jitter
    var last = window.pageYOffset;
    var tucked = false;
    var ticking = false;

    function setTucked(next) {
      if (next === tucked) return;
      tucked = next;
      if (headerHolder) headerHolder.classList.toggle('is-tucked', next);
      if (bar) {
        bar.classList.toggle('is-showing', next);
        bar.setAttribute('aria-hidden', next ? 'false' : 'true');
      }
    }

    function onScroll() {
      var y = window.pageYOffset;
      var delta = y - last;
      if (Math.abs(delta) < DEADZONE) { ticking = false; return; }
      if (y < SHOW_AFTER) setTucked(false);
      else setTucked(delta > 0);
      last = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(onScroll);
    }, { passive: true });

    // Opening the menu or the cart drawer should never leave the bar on top of it.
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-toggle], [data-cart-toggle]')) setTucked(false);
    });

    if (!bar) return;

    // On the product page the bar drives the real form, so the customer's pack
    // and refill choice carry through, and it mirrors the live price.
    var addBtn = bar.querySelector('[data-shop-bar-add]');
    var priceOut = bar.querySelector('[data-shop-bar-price]');
    var form = document.querySelector('[data-product-form]');
    if (addBtn && form) {
      addBtn.addEventListener('click', function () {
        var real = form.querySelector('[data-add-button]');
        if (real) real.click();
      });
    }
    var priceSrc = document.querySelector('.product__price [data-price]');
    if (priceOut && priceSrc) {
      var sync = function () { priceOut.textContent = priceSrc.textContent; };
      sync();
      new MutationObserver(sync).observe(priceSrc, { childList: true, characterData: true, subtree: true });
    }
  })();

  /* ---------- Discount code ---------- */
  /* Shopify applies a code to the session via /discount/<code>, then sends the
     shopper back where they were, so the cart re-renders with it applied. */
  document.addEventListener('click', function (e) {
    var go = e.target.closest('[data-discount-apply]');
    if (!go) return;
    var wrap = go.closest('.cart-discount');
    var input = wrap && wrap.querySelector('[data-discount-input]');
    var code = input && input.value.trim();
    if (!code) { if (input) input.focus(); return; }
    go.disabled = true;
    go.textContent = 'Applying\u2026';
    var back = window.location.pathname === '/cart' ? '/cart' : '/cart';
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(back);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-discount-input]');
    if (!input) return;
    e.preventDefault();
    var wrap = input.closest('.cart-discount');
    var btn = wrap && wrap.querySelector('[data-discount-apply]');
    if (btn) btn.click();
  });

  /* ---------- Cart page: auto-submit quantity changes ---------- */
  document.querySelectorAll('[data-cart-form] input[name^="updates"]').forEach(function (input) {
    input.addEventListener('change', function () { input.closest('form').submit(); });
  });
})();
